import React from 'react';
import { t } from '../components/common/Translate';
import { currencySign } from './currencySign';
import { Auth } from '../config/configuration/react';

const counterOfferDisplay = (item, status, saleStatus, winner, onChangeCounterOfferDetails) => {
  const isBuyer = Auth.roleId() === 1;
  if (!item.counter_offer && !status && saleStatus === 'winner_to_designate' && !winner) {
    return (
      <>
        <button
          type="button"
          className="btn btn-1-outline mr-2"
          onClick={() => onChangeCounterOfferDetails(item)}
          disabled={isBuyer}
        >
          {t('makeCounterOffer')}
        </button>
      </>
    );
  }
  if (item.counter_offer && item.counter_offer.is_accepted === null && status) {
    return (
      <>
        <div className="text-secondary">
          {t('counterOfferSent')}
          <b className="d-block font-weight-bold">
            {currencySign(parseInt(item.counter_offer.amount, 10).toLocaleString())}
          </b>
        </div>
      </>
    );
  }
  if (item.counter_offer && item.counter_offer.is_accepted === true && status) {
    return (
      <>
        <div className="text-success">
          {t('counterOfferAccepted')}
          <b className="d-block font-weight-bold">
            {currencySign(parseInt(item.counter_offer.amount, 10).toLocaleString())}
          </b>
        </div>
      </>
    );
  }
  if (item.counter_offer && item.counter_offer.is_accepted === false) {
    return (
      <>
        <div className="text-danger">
          {t('counterOfferDeclined')}
          <b className="d-block font-weight-bold">{currencySign(parseInt(item.amount, 10).toLocaleString())}</b>
        </div>
      </>
    );
  }

  return <>-</>;
};

export default counterOfferDisplay;
